import { render } from "./extra_buttons.vue?vue&type=template&id=28a77a1a"
import script from "./extra_buttons.js?vue&type=script&lang=js&external"
export * from "./extra_buttons.js?vue&type=script&lang=js&external"

import "./extra_buttons.vue?vue&type=style&index=0&id=28a77a1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__